/**
 * Caminhos do menu citados em mensagens, dicas e documentação: sempre os nomes REAIS das
 * opções da tela. Um teste da tela confere cada etapa contra o menu lateral e as seções das
 * Configurações fiscais, para que nenhum texto aponte para um menu que não existe.
 */
export const MENU_PATH = {
  clientes: "Cadastros → Clientes",
  fornecedores: "Cadastros → Fornecedores",
  produtos: "Cadastros → Produtos e embalagens",
  configuracoesFiscais: "Fiscal → Configurações fiscais",
  dadosFiscais: "Fiscal → Configurações fiscais → Dados fiscais e provedor",
  series: "Fiscal → Configurações fiscais → Séries",
  pendenciasFiscais: "Fiscal → Pendências fiscais",
  regrasFiscais: "Fiscal → Regras tributárias",
} as const;
